import _ from 'lodash';

const processStrategy = (bleAnchor) => {
  const relations = {};
  const omit = [];
  return { ..._.omit(bleAnchor, omit), ..._.pickBy(relations, _.identity) };
};

export default {
  key: 'bleAnchor',
  definition: {},
  processStrategy,
};
